<div class="d-flex flex-column p-2">
    <app-search-filter>
        <div class="row">
            <div class="col-3">
                <label for="symbol" class="form-label font-12">نماد:</label>
                <app-symbol-search (selectSearchSymbol)="selected($event)"></app-symbol-search>
            </div>
            <!-- <div class="col-3">
                <label for="source" class="form-label font-12">منبع:</label>
                <select class="form-select" id="source" [(ngModel)]="source">
                    <option value="null"></option>
                    <option value="1">Tsetmc</option>
                    <option value="2">کدال</option>
                </select>
            </div> -->
            <div class="col-3">
                <label for="reviewStatus" class="form-label font-12">وضعیت بررسی:</label>
                <select class="form-select" id="reviewStatus" [(ngModel)]="reviewStatus">
                    <option value="null"></option>
                    <option value="1">درحال بررسی</option>
                    <option value="2">رد شده</option>
                    <option value="3">تایید شده</option>
                </select>
            </div>

            <div class=" col-3 d-flex align-items-end justify-content-end">
                <button class="btn btn-primary btn-sm" (click)="searchTable()">جستجو</button>
            </div>
        </div>
    </app-search-filter>
    <hr class="my-4" />
    <!-- Table content -->
    <div *ngIf="symbolShareHoldersItems">
        <app-table [data]="symbolShareHoldersItems" [KeyName]="KeyName" [columnName]="columnName"
            [isLoading]="isLoading" [totalRecords]="totalRecords" [pageSize]="pageSize" [(page)]="page"
            [isExpandable]="false"  (changePageEvent)="changePage($event)"
            (changeSizeEvent)="changeSize($event)" (clickOnRow)="openStatusModal($event)">
        </app-table>
    </div>
</div>